import React, { ReactNode, useCallback, useMemo } from 'react';
import cx from 'clsx';

import styles from './index.module.scss';
import { withHttp } from '@/utils';
// import type { PreviewCard } from '@/hooks/editor';
import { useDeviceTypeIsMobile } from '@/hooks';
import { FallbackPreviewImage } from '@/assets/editor';

export type PreviewCard = {
  type: 'summary' | 'summary_large_image';
  title: string;
  url: string;
  host: string;
  icon: {
    thumbnail_url: string;
    url: string;
  };
  description: string;
  id: string;
};

const SUPPORT_PREVIEW_CARD_TYPE = ['summary', 'summary_large_image'];
export const PreviewCardContainer = (props: {
  previewCard?: PreviewCard;
  className?: string;
  enableNavigation?: boolean;
  onOpenUrl?: (url: string) => void;
  children?: ReactNode;
}) => {
  const { previewCard, className, enableNavigation, onOpenUrl, children } = props;
  const targetUrl = useMemo(() => withHttp(previewCard?.url || ''), [previewCard?.url]);

  const isMobile = useDeviceTypeIsMobile();

  const displayImageUrl = useMemo(
    () => previewCard?.icon.url || previewCard?.icon.thumbnail_url,
    [previewCard?.icon.thumbnail_url, previewCard?.icon.url],
  );
  const handleCardClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();

      if (targetUrl && enableNavigation) {
        if (onOpenUrl) {
          onOpenUrl(targetUrl);
        } else {
          window.open(targetUrl);
        }
      }
    },
    [targetUrl, enableNavigation],
  );

  if (!previewCard || !SUPPORT_PREVIEW_CARD_TYPE.includes(previewCard.type)) {
    return null;
  }

  if (previewCard.type === 'summary_large_image') {
    return (
      <div
        onClick={handleCardClick}
        className={cx(
          styles.previewCardWrapperLarge,
          enableNavigation && styles.isNav,
          isMobile && styles.isMobile,
          className,
        )}>
        {children}
        <div className={cx(styles.previewCardTop, isMobile && styles.isMobile)}>
          <img
            className={cx(styles.previewCardLeftImage, !displayImageUrl && styles.fallbackImage)}
            src={displayImageUrl || FallbackPreviewImage}
            alt=""
          />
        </div>
        <div className={styles.previewCardBottom}>
          <div className={styles.previewCardUrl}>{previewCard.host}</div>
          <div className={styles.previewCardTitle}>{previewCard.title}</div>
          {isMobile ? null : (
            <div className={styles.previewCardDesc}>{previewCard.description}</div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      onClick={handleCardClick}
      className={cx(
        styles.previewCardWrapper,
        enableNavigation && styles.isNav,
        isMobile && styles.isMobile,
        className,
      )}>
      {children}
      <div className={cx(styles.previewCardLeft, isMobile && styles.isMobile)}>
        <img
          className={cx(styles.previewCardLeftImage, !displayImageUrl && styles.fallbackImage)}
          src={displayImageUrl || FallbackPreviewImage}
          alt=""
        />
      </div>
      <div className={styles.previewCardRight}>
        <div className={styles.previewCardUrl}>{previewCard.host}</div>
        <div className={styles.previewCardTitle}>{previewCard.title}</div>
        {isMobile ? null : <div className={styles.previewCardDesc}>{previewCard.description}</div>}
      </div>
    </div>
  );
};
